import React from 'react';
import { Link } from 'react-router-dom';
import ServiceMainImg from '../../assets/img/Services/services.jpg';
import ServiceHighlights from '../../components/ServiceHighlights';

const Services: React.FC = () => {
  const serviceList = [
    "Application Development", "eCommerce Solutions", "Offshore Outsourcing",
    "Customer Relationship Management - CRM", "Managed Services", "RFID Solutions",
    "Web Design & Development", "Content Management System (CMS)",
    "Enterprise Application Integration", "Enterprise Resource Planning (ERP)",
    "Service Oriented Architecture Implementation (SOA)"
  ];

  return (
    <div className="services-page">
      <div className="breadcrumbs">
        <div className="shell breadcrumbs-inner">
          <h1>Services</h1>
          <ul className="breadcrumb-list">
            <li><Link to="/">Home</Link></li>
            <li className="active">Services</li>
          </ul>
        </div>
      </div>

      <div className="shell">
        <div className="hero-grid" style={{ padding: '40px 0' }}>
          <div className="hero-copy">
            <p className="lead">
              OneSoft is a premier IT Consulting and Outsourcing company. Committed to delivering 
              innovation, OneSoft collaborates with its clients to provide high quality solutions 
              at very competitive prices.
            </p>
            
            <h3 style={{ color: 'var(--accent)', marginTop: '20px' }}>At OneSoft we work to offer you:</h3>
            <ul className="unstyled-list" style={{ marginTop: '15px' }}>
              <li style={{ marginBottom: '10px' }}>
                <span style={{ color: 'var(--accent)', marginRight: '10px' }}>✓</span> High Quality solutions that achieves real business outcome.
              </li>
              <li style={{ marginBottom: '10px' }}>
                <span style={{ color: 'var(--accent)', marginRight: '10px' }}>✓</span> Reliable alternative to in-house IT recourses.
              </li>
              <li style={{ marginBottom: '10px' }}>
                <span style={{ color: 'var(--accent)', marginRight: '10px' }}>✓</span> Cost Effective Solutions through our outsourced Development Centers.
              </li>
              <li style={{ marginBottom: '10px' }}>
                <span style={{ color: 'var(--accent)', marginRight: '10px' }}>✓</span> End to end IT related services for all your IT needs.
              </li>
            </ul>

            <h3 style={{ color: 'var(--accent)', marginTop: '30px' }}>Business Solutions:</h3>
            <div className="pill-row" style={{ marginTop: '15px', flexWrap: 'wrap' }}>
              {serviceList.map((service, index) => (
                <span key={index} className="glass-pill" style={{ marginBottom: '10px' }}>{service}</span>
              ))}
            </div>
          </div>
          <div className="hero-visual">
            <div className="glass-card" style={{ padding: '0' }}>
               <img src={ServiceMainImg} alt="Services" style={{ width: '100%', borderRadius: '20px' }} />
            </div>
          </div>
        </div>
      </div>

      <ServiceHighlights />
    </div>
  );
};

export default Services;
